// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_cz-2";
export var aiChatCartContainerExit = "_cz-4";
export var aiChatContainerLarge = "_cz-0";
export var aiChatContainerSmall = "_cz-1";
export var aiChatIcon = "_cz-6";
export var slideInFromRight = "_cz-3";
export var slideOutToRight = "_cz-5";